var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
      if(this.isTouchDevice()===false) {
        this.querySelectorAll('.swiper-thumb__container--horizontal').forEach((item) => {
          var _this = this;
          item.addEventListener("mouseenter", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
            document.body.classList.add('overflow-hidden');
          });
          item.addEventListener("mouseleave", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.classList.remove('overflow-hidden');
            document.body.style.paddingRight = '';
          });
        });
      }
      
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      this.duration = 100;
      this.swiper.addEventListener('slide_inited', this.slideInitedCustom.bind(this), false);
      this.swiper.addEventListener('slide_changed_custom', this.slideChangedCustom.bind(this), false);

      this.closest('.product--thumbnail_slider__mobile') && this.mobileThumbSize();
    }
    isTouchDevice(){
      return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }
    mobileThumbSize(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container');
      if(window.innerWidth > 576 || !swiper__thumb__container) return false;
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
    }
    resizeHandler(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container'),
          w = swiper__thumb__container.offsetWidth,
          item_w = (swiper__thumb__container.offsetWidth - 10 * 4)/5;
      swiper__thumb__container.style.setProperty('--thumb-width', `${item_w}px`);
    }
    slideInitedCustom(){
      var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
      if(sect.querySelector('select-option-js.active')){
        return false;
      }
      var default_media_id = this.getAttribute('data-current-media-id');
      this.changeSlideSwiper(default_media_id, 0);
    }
    slideChangedCustom(){
      if(!this.querySelector('.swiper-slide-active [data-media-id]')) return false;
      var _this = this;
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.horizontaldesign(_id);
        },0);
      }
      else{
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.verticaldesign(_id);
        },0);
      }
      setTimeout(function(){
        _this.playActiveMedia(_this.querySelector('.swiper-slide-active [data-media-id]'));
      },100);
    }
    clickHandler(e){
      const thumb = e.target.closest('.swiper-thumb');
      if(!thumb || !this.contains(thumb)) return;

      e.preventDefault();

      const activeThumb = this.querySelector('.swiper-thumb.active');
      if(activeThumb) activeThumb.classList.remove('active');
      thumb.classList.add('active');

      const mediaId = thumb.getAttribute('data-media-id');
      this.changeSlideSwiper(mediaId, 0);
    }
    changeSlideSwiper(mediaId, delay){
      delay = delay === undefined || delay === null ? 0 : delay;
      const swiperSlider = this.querySelector('swiper-slider');
      if(!swiperSlider || !mediaId) return;

      const media = swiperSlider.querySelector(`[data-media-id="${mediaId}"]`);
      if(!media) return;

      const targetSlide = media.closest('.swiper-slide');
      if(!targetSlide) return;

      const slides = Array.from(swiperSlider.querySelectorAll('.swiper-slide'));
      const index = slides.indexOf(targetSlide);
      if(index < 0) return;

      let attempts = 0;
      const selectWhenReady = () => {
        const instance = swiperSlider.swiper;
        if(instance && typeof instance.slideTo === 'function'){
          if(typeof instance.update === 'function') instance.update();
          instance.slideTo(index, delay, true);
          if(typeof instance.updateAutoHeight === 'function') instance.updateAutoHeight(delay);
          return;
        }
        attempts += 1;
        if(attempts < 50) window.setTimeout(selectWhenReady, 100);
      };
      selectWhenReady();
    }
    changeSlide(_id){
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        this.horizontaldesign(_id);
      }
      else{
        this.verticaldesign(_id);
      }
      this.changeSlideSwiper(_id);
    }
    verticaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      if(!item) return false;
      const activeItem = this.swiperthumbcontainer.querySelector('.active');
      if(activeItem) activeItem.classList.remove('active');
      item.classList.add('active');

      var _y = item.offsetTop-this.swiperthumbcontainer.offsetTop,
          _h = this.swiperthumbcontainer.offsetHeight,
          main_scrolltop = this.swiperthumbcontainer.scrollTop,
          item_y = _y-main_scrolltop+item.offsetHeight;

      if(item_y > _h){
        temp = main_scrolltop + (item_y-_h);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
      else if(_y < main_scrolltop){
        temp = this.swiperthumbcontainer.scrollTop - (main_scrolltop - _y);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
    }
    horizontaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      if(!item) return false;
      const activeItem = this.swiperthumbcontainer.querySelector('.active');
      if(activeItem) activeItem.classList.remove('active');
      item.classList.add('active');
    
      var _x = item.offsetLeft-this.swiperthumbcontainer.offsetLeft,
          _w = this.swiperthumbcontainer.offsetWidth,
          main_scrollleft = this.swiperthumbcontainer.scrollLeft,
          item_x = _x-main_scrollleft+item.offsetWidth;

      var delta = window.innerWidth <= 576 ? 15 : 0;
      if(item_x > _w){
        temp = main_scrollleft + (item_x-_w) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
      else if(_x < main_scrollleft){
        temp = this.swiperthumbcontainer.scrollLeft - (main_scrollleft - _x) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
    }
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('swiper-slider-container', swiperSliderContainer);
}

elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {
  class themeLightbox extends HTMLElement {
    constructor() {
      super();
      var slides = this.querySelectorAll('.swiper-slide'),
          bullets = this.querySelector('.swiper-pagination');
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
      this.querySelector('.theme-lightbox__toggle').addEventListener("click", this.close.bind(this), false);
    }
    resizeHandler(){
      this.querySelectorAll('.theme-lightbox__image').forEach((item) => {
        var ww = window.innerWidth - 218,
            wh = window.innerHeight - 136,
            iw = item.naturalWidth,
            ih = item.naturalHeight,
            wr = ww/iw;
        if(iw > ih ){
          if(ih*wr >= wh){
            item.classList.remove('theme-lightbox__image--wide');
          }
          else{
            item.classList.add('theme-lightbox__image--wide');
          }
        }
      });
    }
    open(data_media_id){
      this.classList.add('active');
      setTimeout(() => {
        this.classList.add('animate');
      });
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');

      
      const media = this.querySelector(`[data-media-id="${data_media_id}"]`);
      const slider = this.querySelector('swiper-slider');
      if(!media || !slider) return;
      const item_img = media.closest('.swiper-slide');
      const slides = Array.from(slider.querySelector('.swiper-wrapper').children);
      const index = slides.indexOf(item_img);
      if(index < 0) return;

      let attempts = 0;
      const openWhenReady = () => {
        if(slider.swiper && typeof slider.swiper.slideTo === 'function'){
          if(typeof slider.swiper.update === 'function') slider.swiper.update();
          slider.swiper.slideTo(index, 0, true);
          return;
        }
        attempts += 1;
        if(attempts < 50) window.setTimeout(openWhenReady, 100);
      };
      openWhenReady();
    }
    close() {
      this.classList.remove('animate');
      setTimeout(() => {
        this.classList.remove('active');
      }, 500);
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
      window.pauseAllMedia();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('theme-lightbox', themeLightbox);
}

elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
    }
    clickHandler(e){
      var id = this.getAttribute('data-id'),
          item = document.getElementById(id),
          data_media_id = this.getAttribute('data-media-id');
      item.open(data_media_id);
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}

/* Saron product gallery click fallback */
(function () {
  function selectProductMedia(thumb) {
    const container = thumb.closest('swiper-slider-container');
    if (!container) return;

    const slider = container.querySelector('swiper-slider');
    const mediaId = thumb.getAttribute('data-media-id');
    if (!slider || !mediaId) return;

    const wrapper = slider.querySelector(':scope > .swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children).filter((item) => item.classList.contains('swiper-slide'));
    const targetIndex = slides.findIndex((slide) => {
      const media = slide.querySelector('[data-media-id]');
      return media && media.getAttribute('data-media-id') === mediaId;
    });
    if (targetIndex < 0) return;

    container.querySelectorAll('.swiper-thumb.active').forEach((item) => item.classList.remove('active'));
    thumb.classList.add('active');

    let attempts = 0;
    const goToMedia = function () {
      if (slider.swiper && typeof slider.swiper.slideTo === 'function') {
        if (typeof slider.swiper.update === 'function') slider.swiper.update();
        slider.swiper.slideTo(targetIndex, 0, true);
        if (typeof slider.swiper.updateAutoHeight === 'function') slider.swiper.updateAutoHeight(0);
        return;
      }
      attempts += 1;
      if (attempts < 60) window.setTimeout(goToMedia, 100);
    };
    goToMedia();
  }

  document.addEventListener('click', function (event) {
    const thumb = event.target.closest(
      '.product--thumbnail_slider .swiper-thumb, .product--thumbnail_slider__mobile .swiper-thumb'
    );
    if (!thumb) return;
    event.preventDefault();
    selectProductMedia(thumb);
  }, true);
})();
